import React from 'react';
import './App.css';
import './styles/global.css';
import Player from './components/Player/Player';

function App() {
  return (
    <div className="App">
      <Player />
    </div>
  );
}

export default App;
